import { render } from "./TopBacklinks.vue?vue&type=template&id=8523cfc6&scoped=true"
import script from "./TopBacklinks.vue?vue&type=script&lang=js"
export * from "./TopBacklinks.vue?vue&type=script&lang=js"

import "./TopBacklinks.vue?vue&type=style&index=0&id=8523cfc6&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8523cfc6"]])

export default __exports__